/**
 * Model that represents an authenticated user. We match authenticated users as objects in Firestore to
 * real users in the Firebase accounts.
 */
const yup = require('yup');

const {
  requiredString,
  optionalString,
  validateObject
} = require('../utils');

const COLLECTION = 'users';
const SCHEMA = yup.object().shape({
  uid: optionalString().max(200).default("unknown"),
  userEmail: optionalString().max(200).default("unknown"),
  displayName: optionalString().max(200).default("unknown")
});

async function validate(user) {
  return validateObject(SCHEMA, user);
}

module.exports = {
  COLLECTION,
  SCHEMA,
  validate
};